import React, { useEffect, useState } from 'react';
import { Dialog, Form, Input, MessagePlugin, Select, Textarea } from 'tdesign-react';
import useDisableButton from '@/components/DisableWrapper/useDisableButton';
import { toTsOptions } from '@/utils/common';
import TNItems from '../TNItems';

const { FormItem } = Form;
const options = [
  {
    value: 'Java',
    label: 'Java',
  },
  {
    value: 'Python',
    label: 'Python',
  },
];

export default function FormModal({ handleClose, visible, clusterName, request }) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const confirmBtn = useDisableButton({ loading: submitting, content: '确定' });

  useEffect(() => {
    if (!visible) {
      form.reset();
    }
  }, [form, visible]);

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      setSubmitting(true);
      try {
        await request({
          ...fields,
          clusterName,
          namespace: fields.namespace.replace(`${fields.tenant}/`, ''), // 剔除 租户/ 打头
        });
        MessagePlugin.success('操作成功！');
        handleClose(true);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <Dialog
      header='新建任务'
      placement='center'
      visible={visible}
      onConfirm={() => form.submit()}
      confirmBtn={confirmBtn}
      onClose={() => handleClose()}
    >
      <Form form={form} onSubmit={handleSubmit} style={{ width: '90%' }}>
        <TNItems isEdit clusterName={clusterName} />
        <FormItem
          rules={[
            { required: true },
            {
              pattern: /^(([a-z0-9][-a-z0-9]*)?[a-z0-9])?$/,
              message: '小写字母、数字和中划线组成，中划线不能首尾',
            },
          ]}
          name='name'
          label='任务名称'
        >
          <Input />
        </FormItem>
        <FormItem rules={[{ required: true }]} name='runtime' label='任务类型'>
          <Select options={toTsOptions(options)} />
        </FormItem>
        <FormItem name='note' label='说明'>
          <Textarea placeholder='说明' />
        </FormItem>
      </Form>
    </Dialog>
  );
}
